var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShieldChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NewIcon/Checkmark-shield-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.0163 22C12.1863 22 12.4355 21.9293 12.6834 21.8033C18.3829 18.7289 20.2043 17.3154 20.2043 13.7839V6.15794C20.2043 5.0972 19.7818 4.75849 18.9024 4.39883C17.5897 3.86792 14.1319 2.59457 12.8281 2.14601C12.5611 2.05565 12.2882 2 12.0163 2C11.7354 2 11.4625 2.06456 11.1955 2.14601C9.88677 2.58786 6.43388 3.87681 5.12119 4.39883C4.24179 4.74559 3.81934 5.0972 3.81934 6.15794V13.7839C3.81934 17.3154 5.73289 18.5624 11.3491 21.8033C11.5881 21.9382 11.8374 22 12.0163 22ZM10.8915 16.5178C10.5834 16.5178 10.3407 16.3989 10.107 16.0858L7.46211 12.878C7.33432 12.7066 7.25105 12.5044 7.25105 12.2934C7.25105 11.893 7.56316 11.5582 7.96833 11.5582C8.21901 11.5582 8.42113 11.6504 8.63707 11.9416L10.8559 14.7242L15.3455 7.57017C15.5129 7.30566 15.7458 7.16094 15.9875 7.16094C16.3709 7.16094 16.7364 7.43253 16.7364 7.84265C16.7364 8.04572 16.6255 8.25677 16.5196 8.42911L11.6355 16.0858C11.4552 16.3771 11.1996 16.5178 10.8915 16.5178Z",
    fill: "#1F2647"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldChecked);
export default __webpack_public_path__ + "static/media/shield-checked.f392bf8327e2b66dcd44541c849839b4.svg";
export { ForwardRef as ReactComponent };